// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '5c7f9c3a-1391-42d3-827a-d3308a2c7266',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'a71ab8dd-4587-4763-a7e0-986b82f31c0f',
      type: 'Sprite',
      name: 'background',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 40,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '5c7f9c3a-1391-42d3-827a-d3308a2c7266',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: 'acc15d57-a3e1-4c58-a2f4-b7ca03197d9e',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5c7f9c3a-1391-42d3-827a-d3308a2c7266'
    },
    {
      id: '3c2c0165-a156-4346-89b5-b1449a1cbbe9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '6_Booster_Intro_1',
      parent: '5c7f9c3a-1391-42d3-827a-d3308a2c7266',
      data: {
        DEBUG: true
      }
    },
    {
      id: '7eab947c-f50a-4206-8558-cadfec8fed2b',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 314,
      y: 1173,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '5c7f9c3a-1391-42d3-827a-d3308a2c7266'
    },
    {
      id: 'f19a63d0-26c9-40e0-b596-4f2bc60eb470',
      type: 'Container',
      name: 'contentContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5c7f9c3a-1391-42d3-827a-d3308a2c7266'
    },
    {
      id: '431f8b0e-4f87-4461-b4e1-a971d305d9b3',
      type: 'Container',
      name: 'inactiveTabBackgound',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'acc15d57-a3e1-4c58-a2f4-b7ca03197d9e'
    },
    {
      id: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee',
      type: 'Container',
      name: 'tabsContainer',
      className: '',
      x: -55,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'acc15d57-a3e1-4c58-a2f4-b7ca03197d9e',
      stateByName: {
        howToPlay: {
          scale: {
            x: -1
          },
          x: 55
        }
      }
    },
    {
      id: '6aa8e084-7a3d-42ec-b9ca-78953d69a5fe',
      type: 'Text',
      name: 'boostersTabButton',
      className: '',
      x: -195,
      y: 70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      text: 'Boosters',
      localize: true,
      maxWidth: 369,
      maxHeight: 128,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#612519',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'acc15d57-a3e1-4c58-a2f4-b7ca03197d9e'
    },
    {
      id: '7eb5a012-737a-4399-ae56-2988884777f8',
      type: 'Text',
      name: 'howToPlayTabButton',
      className: '',
      x: 196,
      y: 70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      text: 'How to Play',
      localize: true,
      maxWidth: 375,
      maxHeight: 162,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#612519',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'acc15d57-a3e1-4c58-a2f4-b7ca03197d9e'
    },
    {
      id: 'ed324c47-1df5-4d00-99eb-96fba3b22d58',
      type: 'Container',
      name: 'boosterTabContent',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f19a63d0-26c9-40e0-b596-4f2bc60eb470',
      stateByName: {
        howToPlay: {
          visible: false
        }
      }
    },
    {
      id: '19068031-23ed-459e-ad02-5041b197a2c6',
      type: 'Container',
      name: 'helpTabContent',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f19a63d0-26c9-40e0-b596-4f2bc60eb470',
      stateByName: {
        howToPlay: {
          visible: true
        }
      }
    },
    {
      id: '7b448d64-82aa-4ecd-8ed6-ef498de8e09d',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3.802564,
        y: 0.730263
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Tournament_Top_Dark_Part',
      parent: '431f8b0e-4f87-4461-b4e1-a971d305d9b3',
      data: {
        dynamicValues: {
          width: 'width * 1.1'
        }
      }
    },
    {
      id: '71071115-7553-4e2d-a492-d428d8b7e0a7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 115,
      y: -104,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: '2d809c0f-bec1-488c-8180-8dea9e3388a5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 877,
      y: -104,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: 'aaa845d2-fc90-4ad3-9dbe-8f91ee439864',
      type: 'Sprite',
      name: '',
      className: '',
      x: 1639,
      y: -104,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: '39622bd9-de03-46fc-b6a6-7924b168c718',
      type: 'Sprite',
      name: 'activeTabCurve',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Active_Tab_Curve',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: '0cea9255-250b-4ecf-a85d-c0de18806087',
      type: 'Sprite',
      name: '',
      className: '',
      x: -762,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: '37ab1ae8-c401-4c74-8ec4-b355f1b46646',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1524,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: 'a97a2eee-8d5a-433b-95d8-182b0ede255c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -2286,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'topBar',
      parent: 'a3e9aac8-3bd0-4fc9-aa11-0dbdb82083ee'
    },
    {
      id: 'c1970f3d-570d-4ace-a7e8-eb827c9cb6db',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 250,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ed324c47-1df5-4d00-99eb-96fba3b22d58'
    },
    {
      id: 'bcf7126c-f2b6-49da-945e-06ebcc2460f0',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 500,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ed324c47-1df5-4d00-99eb-96fba3b22d58'
    },
    {
      id: '68336527-af93-4c9e-a789-0b9e645d277c',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 750,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ed324c47-1df5-4d00-99eb-96fba3b22d58'
    },
    {
      id: '6c0e4e32-d74a-4e03-8801-8ca977db38f6',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 1000,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ed324c47-1df5-4d00-99eb-96fba3b22d58'
    },
    {
      id: '6d46e92b-05a3-4438-8a06-9691efb11b10',
      type: 'Sprite',
      name: '',
      className: '',
      x: -182,
      y: 380,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'How_To_Play_Step_1',
      parent: '19068031-23ed-459e-ad02-5041b197a2c6'
    },
    {
      id: 'fc193766-7a1a-4590-80e4-4707e6f69985',
      type: 'Sprite',
      name: '',
      className: '',
      x: -182,
      y: 639,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'How_To_Play_Step_2',
      parent: '19068031-23ed-459e-ad02-5041b197a2c6'
    },
    {
      id: '8f55f789-36d6-4b73-a14b-27a80bd810b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: -182,
      y: 905,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'How_To_Play_Step_3',
      parent: '19068031-23ed-459e-ad02-5041b197a2c6'
    },
    {
      id: 'd191b89a-360d-4f1e-a5d6-de6e2feba7b1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 36,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'How_To_Play_Arrow',
      parent: '19068031-23ed-459e-ad02-5041b197a2c6'
    },
    {
      id: '539c0312-b686-4cca-8ecf-97df9f986d16',
      type: 'Sprite',
      name: '',
      className: '',
      x: 36,
      y: 766,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'How_To_Play_Arrow',
      parent: '19068031-23ed-459e-ad02-5041b197a2c6'
    },
    {
      id: '6b7ef634-f117-43d7-bd31-0361c4ad31a9',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 0,
      y: 326,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Place $matching colours$ next to each other to $stack them$',
      localize: true,
      maxWidth: 390,
      maxHeight: 134,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 328,
        breakWords: false,
        lineHeight: 36,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '19068031-23ed-459e-ad02-5041b197a2c6',
      data: {
        colorTags: {
          $: '#FFCD15'
        }
      }
    },
    {
      id: '32742007-a60c-41e9-af1e-78317beea416',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 0,
      y: 588,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Make a $stack of 10+$ to $clear them$ from the board',
      localize: true,
      maxWidth: 390,
      maxHeight: 134,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 328,
        breakWords: false,
        lineHeight: 36,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '19068031-23ed-459e-ad02-5041b197a2c6',
      data: {
        colorTags: {
          $: '#FFCD15'
        }
      }
    },
    {
      id: 'c572c3e1-643c-44d9-94f2-f117757ad274',
      type: 'Text',
      name: '',
      className: 'colorTags_SPL',
      x: 0,
      y: 830,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$Complete level objectives$ to beat the level before you run out of board space!',
      localize: true,
      maxWidth: 390,
      maxHeight: 175,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 328,
        breakWords: false,
        lineHeight: 36,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '19068031-23ed-459e-ad02-5041b197a2c6',
      data: {
        colorTags: {
          $: '#FFCD15'
        }
      }
    },
    {
      id: 'e047d9ca-2e16-4714-8584-9bb5e9373409',
      type: 'Container',
      name: '',
      className: 'boosterIconSlot',
      x: -165,
      y: 54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c1970f3d-570d-4ace-a7e8-eb827c9cb6db'
    },
    {
      id: '6d1049dc-fba6-45a3-a5e7-834634bcbd88',
      type: 'Text',
      name: '',
      className: 'boosterName',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hammer',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c1970f3d-570d-4ace-a7e8-eb827c9cb6db'
    },
    {
      id: '3eb420a6-feca-408e-b50a-2abe58173568',
      type: 'Text',
      name: '',
      className: 'boosterDescription',
      x: 0,
      y: 51,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Tap on an object to hit it',
      localize: true,
      maxWidth: 370,
      maxHeight: 165,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 370,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c1970f3d-570d-4ace-a7e8-eb827c9cb6db'
    },
    {
      id: '7331c23b-52bd-4c98-b5bd-ad7e86457a78',
      type: 'Container',
      name: '',
      className: 'boosterIconSlot',
      x: -165,
      y: 54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bcf7126c-f2b6-49da-945e-06ebcc2460f0'
    },
    {
      id: '98e5f0d4-36b5-40d7-94c6-828a547817df',
      type: 'Text',
      name: '',
      className: 'boosterName',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hammer',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'bcf7126c-f2b6-49da-945e-06ebcc2460f0'
    },
    {
      id: 'a2033cfd-5cb5-4b7f-9aad-b10e24b3e40c',
      type: 'Text',
      name: '',
      className: 'boosterDescription',
      x: 0,
      y: 51,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Tap on an object to hit it',
      localize: true,
      maxWidth: 370,
      maxHeight: 165,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 370,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'bcf7126c-f2b6-49da-945e-06ebcc2460f0'
    },
    {
      id: '4c855daa-b16b-4b17-9019-ea130c3df846',
      type: 'Container',
      name: '',
      className: 'boosterIconSlot',
      x: -165,
      y: 54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '68336527-af93-4c9e-a789-0b9e645d277c'
    },
    {
      id: '5ed32321-8fac-43bf-a159-791abf771c23',
      type: 'Text',
      name: '',
      className: 'boosterName',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hammer',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '68336527-af93-4c9e-a789-0b9e645d277c'
    },
    {
      id: '625f487d-1810-4f21-95f0-58bdd3c15d64',
      type: 'Text',
      name: '',
      className: 'boosterDescription',
      x: 0,
      y: 51,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Tap on an object to hit it',
      localize: true,
      maxWidth: 370,
      maxHeight: 165,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 370,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '68336527-af93-4c9e-a789-0b9e645d277c'
    },
    {
      id: '16e6910d-4795-482c-a364-c7fd0ef11312',
      type: 'Container',
      name: '',
      className: 'boosterIconSlot',
      x: -165,
      y: 54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6c0e4e32-d74a-4e03-8801-8ca977db38f6'
    },
    {
      id: '796ec17c-562e-4b5b-b467-a0d24ce643b3',
      type: 'Text',
      name: '',
      className: 'boosterName',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hammer',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6c0e4e32-d74a-4e03-8801-8ca977db38f6'
    },
    {
      id: 'd9ef7465-199f-40f1-a6f0-46651a620ac3',
      type: 'Text',
      name: '',
      className: 'boosterDescription',
      x: 0,
      y: 51,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Tap on an object to hit it',
      localize: true,
      maxWidth: 370,
      maxHeight: 165,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 370,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6c0e4e32-d74a-4e03-8801-8ca977db38f6'
    },
    {
      id: '148e6e48-f8ac-450a-b210-c1d46b0c6136',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL,boosterRays',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 15645199,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'e047d9ca-2e16-4714-8584-9bb5e9373409'
    },
    {
      id: '2951409f-cdb2-4bc6-80e9-42801c9ddef0',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL,boosterRays',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 15645199,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '7331c23b-52bd-4c98-b5bd-ad7e86457a78'
    },
    {
      id: '0e3b2639-8934-4114-bf49-e921db34b7f6',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL,boosterRays',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 15645199,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '4c855daa-b16b-4b17-9019-ea130c3df846'
    },
    {
      id: 'a7c9b8bc-7e0f-4ee9-bd07-6b09dbda4f38',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL,boosterRays',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 15645199,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '16e6910d-4795-482c-a364-c7fd0ef11312'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'howToPlay'
  ],
  handleResize: false
} as const;

export class HowToPlayPopupLayout {
  static raw = raw;
  root!: Container;
  background!: Sprite & { data: typeof raw['list'][1]['data'] };
  header!: Container;
  closeButton!: Sprite;
  contentContainer!: Container;
  inactiveTabBackgound!: Container;
  tabsContainer!: Container;
  boostersTabButton!: Text;
  howToPlayTabButton!: Text;
  boosterTabContent!: Container;
  helpTabContent!: Container;
  activeTabCurve!: Sprite;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] } | Sprite & { data: typeof raw['list'][12]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][29]['data'] } | Text & { data: typeof raw['list'][30]['data'] } | Text & { data: typeof raw['list'][31]['data'] })[];
  boosterIconSlot!: (Container)[];
  boosterName!: (Text)[];
  boosterDescription!: (Text)[];
  rotate_SPL!: (Sprite)[];
  boosterRays!: (Sprite)[];
  StateName!: 'howToPlay';

  constructor() {
    populate(this, raw);
  }
}
